<nz-drawer
  [nzVisible]="isDrawerVisible"
  [nzMask]="true"
  [nzMaskClosable]="true"
  nzPlacement="right"
  [nzClosable]="false"
  [nzTitle]="'page.qualifications.drawer.title' | translate"
  (nzOnClose)="closeDrawer.emit()"
>
  <ng-container *nzDrawerContent>
    <div class="mb-2">
      <span class="mb-0 filter-label">
        {{ 'general.users' | translate }}
      </span>
      <wilson-users-list-filter
        [placeholder]="'general.users' | translate"
        (modelChange)="onUserIdsChange($event)"
      ></wilson-users-list-filter>
    </div>
    <div class="mb-2">
      <div class="filter-label">
        {{ 'filter.training-qualifications.status' | translate }}
      </div>

      <wilson-training-qualification-v2-status-filter
        (modelChange)="onStatusChange($event)"
      ></wilson-training-qualification-v2-status-filter>
    </div>
    <div class="mb-2">
      <div class="filter-label">
        {{ 'filter.training-qualifications.qualification' | translate }}
      </div>

      <wilson-qualification-v2-filter
        (modelChange)="onQualificationChange($event)"
      ></wilson-qualification-v2-filter>
    </div>
  </ng-container>
</nz-drawer>
